import { createContext, useState, useEffect } from 'react';
import { configData } from "../config";

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [userroles, setRole] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const app_url = configData.APP_URL;
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        setIsLoading(true);
        const response = await fetch(
      app_url+'viewprofile/getuserloggedinroles',
      {
        method: "GET",
  
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    const responsedata = await response.json();
    if(responsedata.data.result === "Success") {
        setUser(responsedata.data.user);
        setRole(responsedata.data.roles);
    }
      } catch (error) {
        console.error(error);
      }finally {
            setIsLoading(false); // Set loading to false after fetch completes (success or error)
          }
    };
    fetchUserData();
  }, []);

  return (
    <AuthContext.Provider value={{ user, userroles,isLoading }}>
      {children}
    </AuthContext.Provider>
  );
};

export { AuthContext, AuthProvider };